import React from 'react';
import { UserFreebet } from '../../../../models';
import { useStore, useTranslation } from '../../../../hooks';
import { T } from '../../../../constants';
import './style.scss';
import { formatDate, formatValue } from '../../../../helpers';

interface ChooseRewardPopupProps {
  selectedRewardId?: number;
  allData: Array<UserFreebet>
  onSelect: (reward: UserFreebet) => void;
}

const ChooseRewardPopup: React.FC<ChooseRewardPopupProps> = ({ allData, selectedRewardId, onSelect }) => {
  const translate = useTranslation();
  const { gameStore } = useStore();
  const { currencySymbol } = gameStore;
  return (
      <>
        <h2 className="free-spin-recived-title">{translate(T.CHOOSE_A_REWARD)}</h2>
        <div className="free-spin-recived">
          {
            allData.map(receivedReward => (
                <div className="free-spin-recived-items" key={receivedReward.id}>
                  <div
                      className={`boosted-jackpot-block free-spins ${selectedRewardId === receivedReward.id ? 'active' : ''}`}
                      onClick={() => onSelect(receivedReward)}
                  >
                    <div className="new-jackpot-block-header">
                      <span className="new-jackpot-title">{translate(T.YOU_HAVE_RECEIVED)}</span>
                    </div>
                      <p className="jackpot-nsp-text free-spins-txt"><span className="free-spins-text-number">{formatValue(receivedReward.remainingCount || receivedReward.count)}</span>{translate(T.FREE_SPINS)}!</p>
                    <div className="jackpot-spin-amount">
                      <p className="spin-amount">{translate(T.SPIN_AMOUNT)}</p>
                      <p className="jackpot-nsp-text spin-amount-number">{formatValue(receivedReward.amount) } {currencySymbol}</p>
                    </div>
                    <div className="jackpot-info-row">
                      <p className="jackpot-date-info">{translate(T.CAN_BE_USED_UNTIL)}:</p>
                      <p className="jackpot-date">{formatDate(new Date(receivedReward.expireDate))}</p>
                    </div>
                    <div className="jackpot-info-row">
                      {
                        receivedReward.minOdd ? (
                            <div className="jackpot-info-col">
                              <p className="jackpot-date-info">{translate(T.MIN_ODD)}:</p>
                              <p className="jackpot-date">{formatValue(receivedReward.minOdd)}</p>
                            </div>
                        ) : null
                      }
                      {
                        receivedReward.maxPayout ? (
                            <div className="jackpot-info-col">
                              <p className="jackpot-date-info">{translate(T.MAX_PAYOUT)}:</p>
                              <p className="jackpot-date">{formatValue(receivedReward.maxPayout)}</p>
                            </div>
                        ) : null
                      }
                    </div>
                  </div>
                </div>
            ))
          }
        </div>
      </>
  )
};

export default ChooseRewardPopup;
